import { React, useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import MainLayout from "../layouts/MainLayout";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

import AuthContext from "../contexts/AuthContext";

function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const history = useNavigate();
  const auth = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    if (auth.token) {
      history("/insurrances", { replace: true });
    }
  });

  const onSubmit = () => {
    if (passwordConfirm) {
      if (passwordConfirm === password) {
        auth.register(name, email, password, () => history("/login"));
      } else {
        toast("Les mots de passe ne correspondent pas !", { type: "error" });
      }
    } else {
      toast.error("Aucun champ ne doit pas etre vide");
    }
  };
  return (
    <MainLayout pageCSS="login-page">
      <Row className="justify-content-center login-container">
        <Col lg={6} md={8}>
          <Card className="login-form">
            <Card.Body>
              <h3 className="text-center">
                <b>{t("register_page_form_header")}</b>
              </h3>

              <Form.Group>
                <Form.Label>
                  {t("register_page_form_input_label_name")}
                </Form.Label>
                <Form.Control
                  label="text"
                  type="text"
                  placeholder={t("register_page_form_input_placeholder_name")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="u-mt-medium">
                <Form.Label>
                  {t("register_page_form_input_label_email")}
                </Form.Label>
                <Form.Control
                  label="text"
                  type="email"
                  placeholder={t("register_page_form_input_placeholder_email")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="u-mt-medium">
                <Form.Label>
                  {t("register_page_form_input_label_password")}
                </Form.Label>
                <Form.Control
                  label="Mot de passe:"
                  type="password"
                  placeholder="Entrer le mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="u-mt-medium">
                <Form.Label>
                  {t("register_page_form_input_label_password_confirm")}
                </Form.Label>
                <Form.Control
                  label={t("register_page_form_input_label_password_confirm")}
                  type="password"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
              </Form.Group>

              <Button
                variant="blue"
                className="login-page-btn-submit u-mt-small btn-block"
                onClick={onSubmit}
                disabled={auth.loading}
              >
                {auth.loading ? (
                  <Spinner
                    variant="standard"
                    as="span"
                    size="sm"
                    role="status"
                    animation="border"
                    aria-hidden="true"
                  />
                ) : (
                  t("register_page_form_register_button")
                )}
              </Button>
              <Link
                to="/login"
                className="login-form__redirect-link u-mt-small"
              >
                {t("register_page_form_register_link")}
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <ToastContainer containerId="an id" draggable={false} />
      </Row>
    </MainLayout>
  );
}

export default Register;
